<app-title-section></app-title-section>
<app-parametre-bar 
    [initialSettings]="documentColumnSettings"
    [documentId]="documentId"
    (primaryColorChange)="onPrimaryColorChange($event)" 
    (downloadPDFRequest)="downloadPDF()"
    (documentSettingsChange)="onDocumentSettingsChange($event)">
</app-parametre-bar>
<div class="card p-1" [style.margin]="'0 60px'" #documentContainer>

    <!-- En-tête -->
    <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center">
            <img [src]="stationLogo" class="logo-img me-2" style="width: 35px; height: auto" alt="Logo">
            <p style="font-size: 22px; color: #2F2B3DE5">{{ stationName }}</p>
        </div>
        <label>
            <strong class="size20">{{ document?.typeDocument?.titre || 'Document' }} / </strong>
            <label class="text-muted size20">{{ getDisplayReference() }}</label>
        </label>
    </div>

    <!-- Ligne 2 : Client + Détails -->
    <div class="items mt-4">
        <!-- CLIENT -->
        <!-- REMPLACE TOUT LE BLOC CLIENT/FOURNISSEUR PAR ÇA -->
        <div  [ngClass]="{'inventaire-items-wrapper': isInventaire()}" style="width: 45%">
        <div class="flex-grow-1" [ngClass]="{'inventaire-client-section': isInventaire()}" style="margin-left: 36px" *ngIf="!isStockDocument() && !isInventaire()">
            <p style="font-size: 15px; color:#2F2B3DE5; font-weight: 700">{{ getPartyLabel() }}</p>
            <hr class="section-line" [style.border-bottom]="'1px solid ' + primaryColor">

            <!-- NOM -->
            <div class="d-flex" *ngIf="!isAchat() && !isClientFieldModified('nomClient')">
                <table>
                    <tr>
                        <td style="width: 170px"><label class="size15">Nom</label></td>
                        <td><label class="size15-400">
                            {{ getPartyName() }}
                        </label></td>
                    </tr>
                </table>
            </div>
            <hr *ngIf="!isAchat() && !isClientFieldModified('nomClient')">

            <!-- IDENTIFIANT -->
            <div class="d-flex" *ngIf="!isAchat() && !isClientFieldModified('identifiant')">
                <table>
                    <tr>
                        <td style="width: 170px">
                            <label class="size15">Identifiant unique</label>
                        </td>
                        <td><label class="size15-400">{{ getPartyIdFiscal() }}</label></td>
                    </tr>
                </table>
            </div>
            <hr *ngIf="!isAchat() && !isClientFieldModified('identifiant')">


            <!-- ADRESSE -->
            <div class="d-flex" *ngIf="!isAchat() && !isClientFieldModified('adresse')">
                <table>
                    <tr>
                        <td style="width: 170px"><label class="size15">Adresse</label></td>
                        <td><label class="size15-400">{{ getPartyAddress() }}</label></td>
                    </tr>
                </table>
            </div>
            <hr *ngIf="!isAchat() && !isClientFieldModified('adresse')">

            <!-- EMAIL -->
            <div class="d-flex" *ngIf="!isAchat() && !isClientFieldModified('email')">
                <table>
                    <tr>
                        <td style="width: 170px"><label class="size15">Email</label></td>
                        <td><label class="size15-400">{{ getPartyEmail() }}</label></td>
                    </tr>
                </table>
            </div>
            <hr *ngIf="!isAchat() && !isClientFieldModified('email')">

            <!-- NIF CLIENT -->
            <div class="d-flex" *ngIf="!isAchat() && !isClientFieldModified('numeroIdentification')">
                <table>
                    <tr>
                        <td style="width: 170px"><label class="size15">Numéro d'identification fiscale</label></td>
                        <td><label class="size15-400">{{ getPartyNumeroIdentification() }}</label></td>
                    </tr>
                </table>
            </div>
            <hr *ngIf="!isAchat() && !isClientFieldModified('numeroIdentification')">

            <!-- CHAMPS UNIQUES ACHAT -->
            <ng-container *ngIf="isAchat()">
                <div class="d-flex" *ngIf="!isFournisseurFieldModified('nomEntreprise')">
                    <table>
                        <tr>
                            <td style="width: 170px"><label class="size15">Entreprise</label></td>
                            <td><label class="size15-400">{{ getEntrepriseName() }}</label></td>
                        </tr>
                    </table>
                </div>
                <hr *ngIf="!isFournisseurFieldModified('nomEntreprise')">
                <div class="d-flex" *ngIf="!isFournisseurFieldModified('numeroIdentification')">
                    <table>
                        <tr>
                            <td style="width: 170px">
                                <label class="size15">Numéro d'identification fiscale</label>
                            </td>
                            <td><label class="size15-400">{{ getPartyIdFiscal() }}</label></td>
                        </tr>
                    </table>
                </div>
                <hr *ngIf="!isFournisseurFieldModified('numeroIdentification')">
                <div class="d-flex" *ngIf="!isFournisseurFieldModified('responsable')">
                    <table>
                        <tr>
                            <td style="width: 170px"><label class="size15">Responsable</label></td>
                            <td><label class="size15-400">{{ getResponsable() }}</label></td>
                        </tr>
                    </table>
                </div>
                <hr *ngIf="!isFournisseurFieldModified('responsable')">

                <div class="d-flex" *ngIf="!isFournisseurFieldModified('telephone')">
                    <table>
                        <tr>
                            <td style="width: 170px"><label class="size15">Téléphone</label></td>
                            <td><label class="size15-400">{{ getPartyPhone() }}</label></td>
                        </tr>
                    </table>
                </div>
                <hr *ngIf="!isFournisseurFieldModified('telephone')">
                <div class="d-flex" *ngIf="!isFournisseurFieldModified('adresse')">
                    <table>
                        <tr>
                            <td style="width: 170px"><label class="size15">Adresse</label></td>
                            <td><label class="size15-400">{{ getAdresseEntreprise() }}</label></td>
                        </tr>
                    </table>
                </div>
                <hr *ngIf="!isFournisseurFieldModified('adresse')">
            </ng-container>
        </div>
        </div>
        <!-- DÉTAILS DU DOCUMENT -->
        <div class="flex-grow-1" [class.ml-auto]="isStockDocument() && !isInventaire()" [ngClass]="{'inventaire-detail-right': isInventaire()}">
            <p style="font-size: 15px; color:#2F2B3DE5; font-weight: 700">Détails du document</p>
            <hr class="section-line" [style.border-bottom]="'1px solid ' + primaryColor">

            <div class="d-flex" *ngIf="isAchat()">
                <table>
                    <tr>
                        <td style="width: 170px"><label class="size15">Référence externe</label></td>
                        <td><label class="size15-400 fw-bold">{{ getRefExterne() }}</label></td>
                    </tr>
                </table>
            </div>
            <hr *ngIf="isAchat()">

            <div class="d-flex">
                <table>
                    <tr>
                        <td style="width: 170px"><label class="size15">Date</label></td>
                        <label class="size15-400">{{ getFormattedDate() }}</label>
                    </tr>
                </table>
            </div>
            <hr>

            <div class="d-flex" *ngIf="isCommande()">
                <table>
                    <tr>
                        <td style="width: 170px"><label class="size15">Date de livraison </label></td>
                        <td><label class="size15-400">{{ getFormattedLivraisonDate() }}</label></td>
                    </tr>
                </table>
            </div>
            <hr *ngIf="isCommande()">

            <!-- Entrepôt pour les types standards -->
            <div class="d-flex" *ngIf="entrepotValidation() && !isStockDocument()">
                <table>
                    <tr>
                        <td style="width: 170px"><label class="size15">Entrepôt</label></td>
                        <td><label class="size15-400">{{ getEntrepot() }}</label></td>
                    </tr>
                </table>
            </div>
            <hr *ngIf="entrepotValidation() && !isStockDocument()">

            <!-- Entrepôts pour INVENTAIRE -->
            <div class="d-flex" *ngIf="isStockDocument() && document?.typeDocument?.titre === 'INVENTAIRE'">
                <table>
                    <tr>
                        <td style="width: 170px"><label class="size15">Entrepôt</label></td>
                        <td><label class="size15-400">{{ getEntrepot() }}</label></td>
                    </tr>
                </table>
            </div>
            <hr *ngIf="isStockDocument() && document?.typeDocument?.titre === 'INVENTAIRE'">

            <!-- Entrepôts pour BON TRANSFERT -->
            <div class="d-flex" *ngIf="isStockDocument() && document?.typeDocument?.titre === 'BON TRANSFERT'">
                <table>
                    <tr>
                        <td style="width: 170px"><label class="size15">Entrepôt initial</label></td>
                        <td><label class="size15-400">{{ getEntrepotInitial() }}</label></td>
                    </tr>
                </table>
            </div>
            <hr *ngIf="isStockDocument() && document?.typeDocument?.titre === 'BON TRANSFERT'">
            <div class="d-flex" *ngIf="isStockDocument() && document?.typeDocument?.titre === 'BON TRANSFERT'">
                <table>
                    <tr>
                        <td style="width: 170px"><label class="size15">Entrepôt destination</label></td>
                        <td><label class="size15-400">{{ getEntrepotDestination() }}</label></td>
                    </tr>
                </table>
            </div>
            <hr *ngIf="isStockDocument() && document?.typeDocument?.titre === 'BON TRANSFERT'">

            <div class="d-flex">
                <table>
                    <tr>
                        <td style="width: 170px"><label class="size15">Projet</label></td>
                        <td>
                            <label class="size15-400">
                                <ng-container *ngIf="projetDisplay; else noProject">
                                     {{ projetDisplay.titre }}
                                </ng-container>
                                <ng-template #noProject>--</ng-template>
                            </label>
                        </td>
                    </tr>
                </table>
            </div>
            <hr>

            <div class="d-flex" *ngIf="isAchat()  && document?.typeDocument?.titre === 'FACTURE FOURNISSEUR'">
                <table>
                    <tr>
                        <td style="width: 170px"><label class="size15">Catégories</label></td>
                        <td><label class="size15-400">{{ getCategories() }}</label></td>
                    </tr>
                </table>
            </div>
            <hr *ngIf="isAchat()  && document?.typeDocument?.titre === 'FACTURE FOURNISSEUR'">

            <div class="d-flex">
                <table>
                    <tr>
                        <td style="width: 170px"><label class="size15">Note</label></td>
                        <td><label class="size15-400">{{ document?.note || '--' }}</label></td>
                    </tr>
                </table>
            </div>
            <hr>
        </div>
    </div>

    <!-- PRODUITS -->
    <div class="products-section">
        <table class="products-table">
            <thead [style.height]="'56px'" [style.backgroundColor]="getColorWithOpacity(0.16)">
            <tr>
                <th>DÉSIGNATION / RÉFÉRENCE</th>
                <th *ngIf="documentColumnSettings.quantite">QUANTITÉ</th>
                <th *ngIf="documentColumnSettings.unite">UNITÉ</th>
                <th *ngIf="documentColumnSettings.prixUnitaire">{{ isAchat() ? "PRIX D'ACHAT" : 'VALEUR UNITAIRE' }}</th>
                <th *ngIf="documentColumnSettings.tva">TVA</th>
                <th *ngIf="documentColumnSettings.remise">REMISE</th>
                <th *ngIf="shouldShowQuantiteDisponibleColumn()">QUANTITÉ DISPONIBLE</th>
                <th>TOTAL HT</th>
            </tr>
            </thead>
            <tbody>
            <ng-container *ngFor="let ligne of document?.lignesDocument">
                <tr>
                    <td class="approve-ligne-cel approve-ligne-cel--stack">
                        <div class="approve-ligne-cel__main">{{ getLigneLibelleAvecRefFabricant(ligne) }}</div>
                        <div class="approve-ligne-cel__sub approve-ligne-cel__sub--code-bar">
                            {{ getLigneCodeBarDisplay(ligne) }}
                        </div>
                        <div
                            *ngIf="getLigneCouleurTailleDisplay(ligne)"
                            class="approve-ligne-cel__sub approve-ligne-cel__sub--couleur-taille"
                        >
                            {{ getLigneCouleurTailleDisplay(ligne) }}
                        </div>
                    </td>
                    <td *ngIf="documentColumnSettings.quantite">{{ ligne.qnt | number:'1.0-0' }}</td>
                    <td *ngIf="documentColumnSettings.unite">{{ ligne.unite || '--' }}</td>
                    <td *ngIf="documentColumnSettings.prixUnitaire">
                        <ng-container *ngIf="isAchat(); else cellPrixUnitaireVente">
                            {{ getPrixAchatLigneApprove(ligne) | number:'1.3-3' }} TND
                        </ng-container>
                        <ng-template #cellPrixUnitaireVente>{{ ligne.prix_ht | number:'1.3-3' }} TND</ng-template>
                    </td>
                    <td *ngIf="documentColumnSettings.tva">{{ ligne.tva || 0 }}%</td>
                    <td *ngIf="documentColumnSettings.remise">{{ ligne.remise || 0 }}%</td>
                    <td *ngIf="shouldShowQuantiteDisponibleColumn()">{{ getStockQuantityForDisplay(ligne) }}</td>
                    <td>{{ (ligne.prix_ht * ligne.qnt) | number:'1.3-3' }} TND</td>
                </tr>
                <!-- Afficher les lignes supplémentaires (ajout_ligne) triées par order -->
                <ng-container *ngFor="let ajoutLigne of getSortedAjoutLignes(ligne?.ajout_ligne)">
                    <!-- Séparateur -->
                    <tr *ngIf="isSeparator(ajoutLigne)">
                        <td [attr.colspan]="getTableColumnCount()" class="table-input" style="padding: 4px 0;">
                            <div style="border-top: 2px solid #134ADB; width: 100%; margin: 4px 0;"></div>
                        </td>
                    </tr>
                    
                    <!-- Rubrique (heading) -->
                    <tr *ngIf="isRubrique(ajoutLigne)">
                        <td [attr.colspan]="getTableColumnCount()" class="table-input" style="padding: 8px 16px;">
                            <div style="font-size: 14px; font-weight: 700; color: #134ADB;">
                                {{ ajoutLigne.rubrique }}
                            </div>
                        </td>
                    </tr>
                    
                    <!-- Texte -->
                    <tr *ngIf="isText(ajoutLigne)">
                        <td [attr.colspan]="getTableColumnCount()" class="table-input" style="padding: 8px 16px;">
                            <div style="font-size: 14px; font-weight: 400; color: rgba(47, 43, 61, 0.9); white-space: pre-wrap;">
                                {{ ajoutLigne.contenu_text }}
                            </div>
                        </td>
                    </tr>
                    
                    <!-- Sous-total -->
                    <tr *ngIf="isSubtotal(ajoutLigne)">
                        <td [attr.colspan]="getTableColumnCount() - 1" class="table-input"></td>
                        <td class="table-input" style="text-align: center; padding: 8px;">
                            <div style="font-size: 14px; font-weight: 400; color: rgba(47, 43, 61, 0.7); text-align: center;">
                                Sous-total
                            </div>
                            <div style="font-size: 14px; font-weight: 400; color: rgba(47, 43, 61, 0.9); text-align: center;">
                                {{ ajoutLigne.sous_total | number:'1.3-3' }} TND
                            </div>
                        </td>
                    </tr>
                </ng-container>
            </ng-container>
            </tbody>
        </table>
    </div>

    <!-- TVA + TOTAUX -->
    <div class="d-flex align-items-start justify-content-between mt-4">
        <!-- TVA -->
        <div style="position: relative; left: 50%; transform: translateX(-80%);">
            <table class="products-table" style="width: 400px;">
                <thead [style.height]="'56px'" [style.backgroundColor]="getColorWithOpacity(0.16)">
                <tr>
                    <th>TVA</th>
                    <th>BASE</th>
                    <th>MONTANT</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let tva of tvaSummary">
                    <td class="table-input">{{ tva.rate }}%</td>
                    <td class="table-input">{{ tva.base | number:'1.3-3' }} TND</td>
                    <td class="table-input">{{ tva.amount | number:'1.3-3' }} TND</td>
                </tr>
                </tbody>
            </table>
        </div>

        <!-- TOTAUX -->
        <div style="position: relative; width: 100%; max-width: 400px; margin-left: auto; margin-right: 50px;">
            <table class="table table-borderless text-start rounded totals-table">
                <tbody>
                <tr>
                    <td>Total HT</td>
                    <td>{{ totals.totalHT | number:'1.3-3' }} TND</td>
                </tr>
                <tr>
                    <td>Total TVA</td>
                    <td>{{ totals.totalTVA | number:'1.3-3' }} TND</td>
                </tr>
                <tr>
                    <td>Total TTC</td>
                    <td>{{ totals.totalTTC | number:'1.3-3' }} TND</td>
                </tr>
                <tr>
                    <td>Timbre fiscal</td>
                    <td>{{ totals.timbreFiscal | number:'1.3-3' }} TND</td>
                </tr>
                <tr class="fw-bold">
                    <td>Net à payer</td>
                    <td>{{ totals.netAPayer | number:'1.3-3' }} TND</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>

    <!-- FOOTER : Entreprise toujours affichée ; le reste selon afficherCoordonneesClients -->
    <div class="footer-info d-flex justify-content-between">
        <div class="company-info">
            <p class="size15"><strong>Entreprise</strong></p>
            <p class="information">{{ entreprise.nom }}</p>
            <p class="information">{{ entreprise.adresse }}</p>
            <p class="information">{{ entreprise.ville || '' }} {{ entreprise.pays || '' }}</p>
            <p class="information">Matricule fiscal: {{ entreprise.matricule_fiscal || '--' }}</p>
        </div>

        <ng-container *ngIf="documentColumnSettings.afficherCoordonneesClients">
            <div class="coordinates">
                <p class="size15"><strong>Coordonnées</strong></p>
                <p class="information">{{ stationFooterCoordName }}</p>
                <p class="information">{{ stationFooterCoordEmail }}</p>
                <p class="information">{{ stationFooterCoordPhones }}</p>
            </div>
            <div class="bank-info d-flex align-items-start flex-wrap gap-3">
                <div class="bank-info-text">
                    <p class="size15"><strong>Coordonnées bancaires</strong></p>
                    <p class="information">{{ banque.nom_banque }}</p>
                    <p class="information">{{ banque.rib }}</p>
                </div>
            </div>
            <div class="footer-document-cachet" *ngIf="documentCachetUrl">
                <p style="font-size: 15px; font-weight: 600;">Cachet et Signature</p>
                <img [src]="documentCachetUrl" alt="Cachet" class="footer-document-cachet__img" />
            </div>
        </ng-container>
    </div>
</div>
